import { useState } from 'react';
import Layout from '../components/Layout';
import NotificationSettings from '../components/NotificationSettings';
import { Bell, Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Settings = () => {
  const { i18n } = useTranslation();
  const [activeTab, setActiveTab] = useState('notifications');

  const tabs = [
    { id: 'notifications', label: 'Notifications', icon: Bell },
    { id: 'language', label: 'Language', icon: Globe },
  ];

  const languages = [
    { code: 'en', name: 'English', flag: 'EN' },
    { code: 'fr', name: 'Francais', flag: 'FR' },
    { code: 'de', name: 'Deutsch', flag: 'DE' },
    { code: 'es', name: 'Espanol', flag: 'ES' },
    { code: 'it', name: 'Italiano', flag: 'IT' },
  ];

  return (
    <Layout>
      <div data-testid="settings-page" style={{ maxWidth: 800 }}>
        <h1 style={{ fontSize: 24, fontWeight: 600, marginBottom: 20 }}>Settings</h1>

        {/* Tab Strip */}
        <div className="card-floating tab-strip" style={{ position: 'relative', display: 'flex', gap: 0, padding: 0, marginBottom: 20, overflow: 'hidden' }}>
          {tabs.map(tab => {
            const Icon = tab.icon;
            return (
              <button key={tab.id} onClick={() => setActiveTab(tab.id)}
                className={`tab-btn${activeTab === tab.id ? ' active' : ''}`}>
                <Icon size={15} /> {tab.label}
              </button>
            );
          })}
        </div>

        {/* Content */}
        <section className="card-floating" style={{ position: 'relative' }}>
          <div className="card-body">
            {activeTab === 'notifications' && (
              <div>
                <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 6 }}>Push Notifications</h2>
                <p style={{ color: 'var(--text-muted)', marginBottom: 18, fontSize: 13 }}>
                  Receive real-time alerts for disease outbreaks, pest warnings, weather events, and spray window recommendations.
                </p>
                <NotificationSettings />
              </div>
            )}
            {activeTab === 'language' && (
              <div>
                <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 6 }}>Language Preferences</h2>
                <p style={{ color: 'var(--text-muted)', marginBottom: 18, fontSize: 13 }}>
                  Select your preferred language for the application interface.
                </p>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 10 }}>
                  {languages.map(lang => {
                    const isSelected = i18n.language === lang.code;
                    return (
                      <button key={lang.code} onClick={() => i18n.changeLanguage(lang.code)}
                        style={{
                          display: 'flex', alignItems: 'center', gap: 10, padding: 12,
                          background: isSelected ? 'rgba(198,170,88,0.12)' : 'rgba(255,255,255,0.04)',
                          border: `1px solid ${isSelected ? 'rgba(198,170,88,0.3)' : 'var(--border)'}`,
                          borderRadius: 12, cursor: 'pointer', transition: 'all .15s',
                          color: isSelected ? 'var(--gold)' : 'var(--text-secondary)',
                        }}>
                        <span style={{ fontWeight: 700, fontSize: 12, opacity: 0.6 }}>{lang.flag}</span>
                        <span style={{ fontWeight: 500, flex: 1, textAlign: 'left', fontSize: 13 }}>{lang.name}</span>
                        {isSelected && <span style={{ color: 'var(--gold)', fontSize: 14 }}>✓</span>}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default Settings;
